import * as HighlightIcons from './highlights';

export type HighlightIconId = keyof typeof HighlightIcons;

export const isHighlightIcon = (
  highlight: string
): highlight is HighlightIconId => {
  return highlight in HighlightIcons;
};

interface HighlightIconProps {
  highlight: string;
  className?: string;
}

export const HighlightIcon: React.FC<HighlightIconProps> = ({
  highlight,
  className,
}) => {
  if (isHighlightIcon(highlight)) {
    const Icon = HighlightIcons[highlight];
    return <Icon className={className} />;
  }

  return null;
};
